module.exports = __webpack_public_path__ + "img/question1-with-ref.a9aed581.jpg";